export const dropdownStyle = {
  backgroundColor: 'white',
  borderRadius: '10px',
  boxShadow: '0 0 0 1px #2E62EC40, 0 4px 11px #2E62EC40',
  width: 'auto',
  overflow: 'hidden',
  marginTop: '8px',
  minWidth: '140px',
  maxWidth: `${window.innerWidth - 30}px`,
  zIndex: '999',
};
